import StylesItem from '../model/styles/mx-styles-item';
import { systemStyles } from '../model/styles/system-styles';

/**
 * @ngdoc service
 * @name mx.designer.StylesService
 * @module mx.designer
 *
 * @description
 * A service provides methods for retrieving styles, allowed to use in layout designer properties
 *
 */
export default class StylesService {
	static $inject = ['mx.sb.WorkSpaceLoader.Service'];
	constructor(workspaceLoaderService) {
		this.workspaceLoaderService = workspaceLoaderService;
	}
	/**
	 * @ngdoc method
	 * @name mx.SolutionBuilderAgent.StylesService#getStylesByTag
	 *
	 * @description
	 * Returns available styles by tag
	 * @param {string} tag - string mask to searching appropriate css classes.
	 * @returns {StylesItem[]} result - an array of style items
	 */
	getStylesByTag(tag) {
		const data = this.loadClasses();
		return data.filter((item) => item.tags.includes(tag));
	}

	loadClasses() {
		return systemStyles.concat(this.workspaceLoaderService.getCustomStyles()).map((item) => new StylesItem(item));
	}

	registerStyles(styleConfig) {
		this.workspaceLoaderService.registerStyles(styleConfig);
	}
}
